module.exports = __webpack_public_path__ + "img/unilever_logo_light.42a53b6b.svg";